import { BaseApi } from './base.api.js';

export class DelegationApi extends BaseApi {
    constructor(client) {
        super(client, '/delegations');
    }

    mine() { return this.client.get(`${this.basePath}/mine`).then((r) => r.data); }

    toMe() { return this.client.get(`${this.basePath}/to-me`).then((r) => r.data); }

    revoke(id) { return this.client.post(`${this.basePath}/${id}/revoke`, {}).then((r) => r.data); }

    decline(id) { return this.client.post(`${this.basePath}/${id}/decline`, {}).then((r) => r.data); }

    adminCreate(data) { return this.client.post(`${this.basePath}/admin`, data).then((r) => r.data); }
}
